
import {CirfClientInfo} from "./cirf-client-info";
import {BaseEntity} from "../common/base-entity";
import { CirfMatterData } from './cirf-matter-data';
import {CirfMatterContactInfo} from "./cirf-matter-contact-info";
import {CirfInsuranceDetail} from "./cirf-insurance-detail";
import {CirfMortgage} from "./cirf-mortgage";
import {CirfDocument} from "./cirf-document";
import {MatterType} from '../common/model/matter-type';

export type ProvinceCode = 'ON' | 'AB' | 'BC' | 'MB' | 'NB' | 'NS' | 'SK';
export type CirfStatusType =  'CANCELLED' | 'EXPIRED' | 'INPROGRESS' | 'OUTSTANDING' | 'PROCESSED' | 'SUBMITTED' | 'IMPORTINPROGRESS';
export type CirfType =  'MATTER' | 'PARTICIPANT';
export class Cirf extends BaseEntity {

    id : number;
    guid : string;
    matterId : number;
    clientEmail : string;
    formData : string;
    //formData is converted into below property
    cirfMatterData: CirfMatterData = new CirfMatterData();
    cirfDocuments : CirfDocument[] = [];
    expiryDate : string;
    clientName : string;
    status: CirfStatusType;
    propertyAddress: string;
    lawFirm: string;
    matterType: MatterType;
    matterTypeName: string;
    matterCloseDate: string;
    matterAddressOrDescription: string;
    lastUpdatedTimeStamp : number;
    lastSubmittedTimeStamp: number;
    cirfType: CirfType;
    matterParticipantId: number; //only for partial cirfs

    constructor(cirf?: Cirf) {
        super(cirf);
        if (cirf) {
            if(cirf.cirfMatterData) {
                this.cirfMatterData = new CirfMatterData(cirf.cirfMatterData);
            } else if(cirf.formData){
                this.cirfMatterData = new CirfMatterData(JSON.parse(cirf.formData));
            }
            this.cirfDocuments = [];
            if(Array.isArray(cirf.cirfDocuments)) {
                for(let cc of cirf.cirfDocuments) {
                    this.cirfDocuments.push(new CirfDocument(cc));
                }
            }
        }
    }

    get cirfGuid() : string {
        return this.guid;
    }

    get cirfClients(): CirfClientInfo[] {
        return this.cirfMatterData.cirfClients;
    }

    set cirfClients(cirfClients: CirfClientInfo[]) {
        this.cirfMatterData.cirfClients = cirfClients;
    }

    cleanUpCirf() : void {
      this.formData =  JSON.stringify(this.cirfMatterData);
    }

    isSubmitted() : boolean {
        return this.status == 'SUBMITTED';
    }

    isOutstanding() : boolean {
        return this.status == 'OUTSTANDING';
    }

    isExpired() : boolean {
        return this.status == 'EXPIRED';
    }

    isCancelled() : boolean {
        return this.status == 'CANCELLED';
    }

    get matterContactInfo() : CirfMatterContactInfo {
        return this.cirfMatterData.matterContactInfo;
    }

    set matterContactInfo(matterContactInfo: CirfMatterContactInfo) {
        this.cirfMatterData.matterContactInfo = new CirfMatterContactInfo(matterContactInfo);
    }

    get fireInsuranceDetail(): CirfInsuranceDetail {
        return this.cirfMatterData.fireInsuranceDetail;
    }

    set fireInsuranceDetail(cirfInsuranceDetail: CirfInsuranceDetail) {
        this.cirfMatterData.fireInsuranceDetail = new CirfInsuranceDetail(cirfInsuranceDetail);
    }

    get mortgages(): CirfMortgage[] {
        return this.cirfMatterData.mortgages;
    }

    get newMortgages(): CirfMortgage[] {
        return this.cirfMatterData.newMortgages;
    }

    get existingMortgages(): CirfMortgage[] {
        return this.cirfMatterData.existingMortgage;
    }

    isMatterSale() : boolean{
        return (this.cirfMatterData && this.cirfMatterData.matterType && this.cirfMatterData.matterType  == 'SALE')
    }

    isMatterPurchase() : boolean {
        return this.cirfMatterData?.matterType == 'PURCHASE';
    }

    isMatterMortgage() : boolean {
        return this.cirfMatterData?.matterType == 'MORTGAGE';
    }

    isCustomMatter() : boolean {
        return this.cirfMatterData?.isCustomMatter();
    }

    isWillMatter(): boolean {
        return this.cirfMatterData?.matterType  === 'WILL';
    }

    get provinceCode() : ProvinceCode {
        return this.cirfMatterData?.provinceCode;
    }

    isProvinceON() : boolean {
        return this.cirfMatterData?.provinceCode == 'ON';
    }

    isProvinceAB() : boolean {
        return this.cirfMatterData?.provinceCode == 'AB';
    }

    isProvinceNB() : boolean {
        return this.cirfMatterData?.provinceCode == 'NB';
    }

    isMatterCirf(): boolean {
        return this.cirfType == 'MATTER';
    }

    isParticipantCirf(): boolean {
        return this.cirfType == 'PARTICIPANT';
    }

    isInsuranceApplicable() : boolean {
        return !this.isMatterSale() && !this.isCustomMatter() && !this.isWillMatter();
    }

}
